<template>
  <div class="Location">
        <p class="location-title">{{ title }}:</p>
        <div class="location-content" :class="{'location-content-pinyin':title==='酒店首字母'}">
            <p :class="{'active':(searcValue[valueKey]==''||searcValue[valueKey].length==0)&&(valueKey=='room_2_type'&&! searcValue.isCustom||valueKey!='room_2_type')}" @click="unlimited(valueKey)">不限</p>
            <ul class="location-list">
                <!--单选-->
                <template v-if="!isMulti">
                    <li v-for="item in list" :key="item.name" :class="{'active':searcValue[valueKey]==(item.id||item.pinyin)}" @click="clickItem(valueKey,item)">{{item.name||item.pinyin}}</li>
                </template>
                <!--多选-->
                <template v-else>
                    <li v-for="item in list" :key="item.name" :class="{'active':searcValue[valueKey].includes((item.id||item.pinyin))}" @click="clickItem(valueKey,item)">{{item.name||item.pinyin}}</li> 
                </template>
                <!--双床房自定义区间-->
                <li v-if="valueKey==='room_2_type'" @click="$emit('inform', [{key:'isCustom',date:1},{key:valueKey,date:''}]);" :class="{'active':searcValue.isCustom}">自定义区间</li>
                <!--品牌更多-->
                <li v-if="valueKey==='brand'" @click="brandMore=!brandMore">{{brandMore?'收起':'更多'}}<i class="el-icon-arrow-down"></i></li>
            </ul>
            <!--酒店品牌-->
            <div v-if="valueKey==='brand'&&brandMore" class="brand-list">
                <div v-for="item in $GVAR.FacilitiesPlatform" :key="item.name" class="brand-list-lst">
                    <span class="brand-list-lst-span">{{item.type}}</span>
                    <ul class="brand-list-lst-ul">
                        <li v-for="brand in item.brand" :key="brand.name" :class="{'active':searcValue[valueKey]==(item.id||item.pinyin)}" @click="clickItem(valueKey,brand)">{{brand.name}}</li>
                    </ul>
                </div>
            </div>
            <div class="hotel flex-wrap" v-if="valueKey==='room_2_type'&&searcValue.isCustom">
                <div  class="customize">
                    <div class="customize-inptu">
                    <el-input  v-model="defineThe" type="number" :placeholder="'最少'"></el-input>
                    </div>
                    <span class="ml-2">—</span>
                    <div class="customize-inptu ml-2">
                    <el-input  v-model="defineMini" type="number" placeholder="最多"></el-input>
                    </div>
                    <p class="mr-2 unlimited ml-2" @click="customQuantity()">确定</p>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    //表单
    searcValue: {
      type: Object,
      default: () => ({
        room_2_type:'',                  //搜索房间数量
        lon_lat:'',                      //经纬度
        type:'',                         //住宿类型
        star:'',                       //酒店星级
        pinyin:'',                        //酒店首字母 
      })
    },
    //表单值key
    valueKey:{
        type:String,
        default:''
    },
    //分类列表
    list:{
        type:Array,
        default:()=> []
    },
    //分类标题
    title:{
        type:String,
        default:''
    },
    //多选
    isMulti:{
        type:Boolean,
        default:false
    }
  },
  data() {
    return {
        //自定义区间
        isCustom:false,              //是否开启自定义
        defineThe: '',               //自定义区间最少
        defineMini: '',               //自定义区间最多
        //品牌更多
        brandMore:false,             //品牌更多是否展开
    };
  },
  watch: {
    searcValue: {
        handler(newVal, oldVal) {
            if(newVal.isCustom&& this.defineThe==''&&newVal.room_2_range&&newVal.room_2_range!=''){
                this.defineThe=newVal.room_2_range.split(',')[0]
                this.defineMini=newVal.room_2_range.split(',')[1]
            }
        }
    },
  },
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
        //点击分类
        clickItem(valueKey,item){
            //如果是双床房区间，需要特殊处理
            if(valueKey==='room_2_type'){
                this.$emit('inform', [{key:'isCustom',date:''},{key:'room_2_range',date:''}])
            };
            this.$emit('inform', valueKey,item.id||item.pinyin,this.isMulti)
        },
        //不限
        unlimited(valueKey){
            //如果是双床房区间，需要特殊处理
            if(valueKey==='room_2_type'){
                this.$emit('inform', [{key:'isCustom',date:''},{key:'room_2_range',date:''}])
            };
            this.$emit('inform', valueKey,this.isMulti?[]:'')
        },
        //双床房自定义数量
        customQuantity(){
            // 1. 第一步：空值处理（空值转为0）
            let minVal = this.defineThe === '' || isNaN(this.defineThe) ? 0 : this.defineThe*1;
            let maxVal = this.defineMini === '' || isNaN(this.defineMini) ? 0 : this.defineMini*1;
            // 2. 第二步：默认值处理（都为空时，最小值=0，最大值=1000）
            if (minVal ===0 && maxVal === 0) {
            minVal = 0;
            maxVal = 9999;
            }
            // 3. 第三步：值翻转处理（最小值 > 最大值时，交换两者）
            if (minVal > maxVal) {
            [minVal, maxVal] = [maxVal, minVal]; 
            }
            this.defineThe=minVal;
            this.defineMini=maxVal;
            // this.room_2_type='';
            this.$emit('inform', 'room_2_range',`${minVal},${maxVal}`)
            // this.room_2_range=`${minVal},${maxVal}`;
        }
  }
};
</script>

<style lang="scss" scoped>
    .Location{
        display: flex;
        margin-top: 16px;
    }
    .location-title{
        margin-right: 20px;
        width: 8%;
        line-height: 26px;
        text-align: left;
        font-size: 13px;
    }
    .location-content{
        display: flex;
        flex-wrap: wrap;
        width: 92%;
    }
    .location-content p,.location-list li{
        background-color: #f1f2f4;
        display: inline-block;
        padding: 0 10px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;
    }
    .location-content-pinyin li{
        margin-right: 10px;
    }
    .location-list{
        display: flex;
    }
    .location-list li{
        cursor: pointer;
    }
    .location-list li:not(.active):hover{
        background-color: #e5e7eb;
    }   
    .location-list li i{
        margin-inline-start: 4px;
        color: #666;
    }
    .location-content .active{
        background-color: var(--smtc-color-primary);
        color: #fff;
    }
    .location-list li i{
        margin-inline-start: 2px;
        color: #666;
    }
    .customize{
        display: flex;
        span{
        margin-top: 4px;
        }
    }
    .unlimited{
        background-color: var(--smtc-color-primary) !important;
        height: 18px;
        line-height: 18px;
        border-radius: 4px;
        color: #fff;
        font-size: 12px !important;
        width: 28px;
        text-align: center !important;
    }
    //-----------------------------------
    //酒店品牌
    //-----------------------------------
    .brand-list{
        width: 100%;
    }
    .brand-list-lst{
        width: 100%;
        display: flex;
    }
    .brand-list-lst-span{
        width: 4%;
        margin-right: 22px;
        margin-top: 17px;
        font-size: 12px;
    }
    .brand-list-lst-ul{
        display: flex;
        flex-wrap: wrap;
        width: 92%;
        font-size: 12px;
    }
    .brand-list-lst-ul li{
        background-color: #f1f2f4;
        display: inline-block;
        padding: 0 10px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 16px;
        cursor: pointer;
        margin-top: 10px;
    }
</style>
<style>
    .customize-inptu .el-input__inner{
        line-height: 26px;
        height: 26px;
        font-size: 12px;
        padding: 0 4px;
        text-align: center;
    }
    .customize-inptu{
        width: 50px;
    }
</style>
